
import { Input } from 'element-ui'

export default {
  extends: Input,
}
